'use client';

import React, { useEffect, useRef } from 'react';
import { ProductCardCarouselWrapper } from '../../../product-card/product-card-carousel/product-card-carousel-wrapper';
import { HP_RECENT_VIEW_GA_LIST_NAME } from '../../constants';
import { useViewItemListEvent } from 'hooks/analytics/use-view-item-list-event';
import { RecentViewCarouselProps } from '../types';
import styles from './../recently-viewed.module.scss';

export const RecentViewCarousel = ({
  children,
  products,
  cartDetails
}: RecentViewCarouselProps) => {
  const { fireEvent: fireViewItemListEvent } = useViewItemListEvent();
  const hasViewListItem = useRef(false);

  useEffect(() => {
    const recentViewItemList = {
      item_list_id: HP_RECENT_VIEW_GA_LIST_NAME,
      item_list_name: HP_RECENT_VIEW_GA_LIST_NAME
    };
    const viewCartPayload = {
      products,
      itemListData: recentViewItemList,
      cartItemsData: cartDetails,
      cartId: cartDetails?.orderHeader?.orderId
    };

    if (products?.length > 0 && !hasViewListItem.current) {
      fireViewItemListEvent(viewCartPayload);
      hasViewListItem.current = true;
    }
  }, [cartDetails, products, fireViewItemListEvent]);
  return (
    <ProductCardCarouselWrapper
      gridClassName={styles['recently-viewed-grid-wrapper']}
    >
      {children}
    </ProductCardCarouselWrapper>
  );
};
